import React, { Fragment, useEffect } from 'react'
import ListReels from '@components/reel/list-reel'
import { Container } from '@chakra-ui/react'
import dynamic from 'next/dynamic'
import { useReel } from '@lib/context/reel-context'

const ReelModal = dynamic(() => import('@components/modals/reel'), {
  ssr: false
})

const Reel = () => {
  const { reels, setFilter } = useReel()

  useEffect(() => {
    setFilter('arctic grip tumbler')

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Fragment>
      {reels != null && reels.length > 0 && (
        <Container px={{ base: 4, lg: 5, xl: 8, '2xl': 0 }}>
          <ListReels />
        </Container>
      )}
      <ReelModal />
    </Fragment>
  )
}

export default Reel
